import {
  chatHistoryItemBorderColor,
  chatHistorySecondaryTextColor,
  chatHistoryPrimaryTextColor,
  chatHistoryUnreadBorderColor,
  appButtonFontColor,
} from 'globals/colors';
import { zIndexAboveContent } from 'globals/styles';

export default {
  wrapper: {
    color: '#000000',
    height: 108,
    padding: '25px',
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    flexDirection: 'row',
    fontSize: 12,
    cursor: 'pointer',
    borderBottom: `1px solid ${chatHistoryItemBorderColor}`,
    margin: 5,
  },
  wrapperHover: {
    ':hover': {
      backgroundColor: '#fff',
    },
  },
  messageColumn: {
    flex: '1 auto',
    width: '79%',
    marginLeft: 20,
  },
  nameDateRow: {
    height: 22,
    display: 'flex',
    justifyContent: 'space-between',
  },
  name: {
    display: 'block',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    fontWeight: 500,
    letterSpacing: '0.2px',
    color: chatHistoryPrimaryTextColor,
    lineHeight: 1,
  },
  date: {
    display: 'block',
    color: chatHistorySecondaryTextColor,
    fontSize: 11,
    lineHeight: '12px',
    fontWeight: 500,
    textTransform: 'uppercase',
  },
  messageRow: {
    fontSize: 12,
    fontWeight: 500,
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    paddingRight: 16,
    height: 16,
    color: chatHistorySecondaryTextColor,
  },
  fillerRowOne: {
    background: '#E9E9E9',
    height: 10,
    width: '15%',
  },
  fillerRowTwo: {
    background: '#E9E9E9',
    height: 10,
    width: '100%',
    marginTop: 8,
  },
  fillerRowThree: {
    background: '#E9E9E9',
    height: 10,
    width: '81%',
    marginTop: 8,
  },
  unread: {
    position: 'absolute',
    left: '50px',
    top: '22px',
    zIndex: zIndexAboveContent,
    background: appButtonFontColor,
    height: '28px',
    width: '28px',
    lineHeight: '13px',
    color: '#fff',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: 11,
    fontWeight: 500,
    border: `3px solid ${chatHistoryUnreadBorderColor}`,
    borderRadius: '50%',
  },
  locked: {
    backgroundColor: 'rgba(233,239,244,0.6)',
    position: 'absolute',
    top: 8,
    left: 8,
    right: 8,
    bottom: 8,
    borderRadius: 8,
    zIndex: zIndexAboveContent,
  },
  closedLabel: {
    position: 'relative',
    zIndex: zIndexAboveContent,
  },
};
